const mexico = {
  key: "mexico_documentation",
  image: "Documentation/mexico_documentation.jpg",
  i18n_title: "mexico_documentation.title",
  i18n_description: "mexico_documentation.description",

  toMexico: [
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.valid_passport",
      i18n_tooltip_label: "",
    },
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.identification_INE",
      i18n_tooltip_label: "",
    },
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label:
        "documentation_requirements.consular_registration_or_mexican_nationality_certificate",
      i18n_tooltip_label: "",
    },
  ],
  toUSA: [
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label:
        "documentation_requirements.valid_passport_or_permanent_residence_card",
      i18n_tooltip_label: "",
    },
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.visa",
      i18n_tooltip_label: "",
    },
    {
      link: "/I94",
      tooltip: true,
      underline: true,
      i18n_label: "documentation_requirements.i94_permit",
      i18n_tooltip_label: "documentation_requirements.i94_permit_tooltip",
    },
  ],
  i18n_note: "",
};

const usa = {
  key: "usa_documentation",
  image: "Documentation/usa_documentation.jpg",
  i18n_title: "usa_documentation.title",
  i18n_description: "usa_documentation.description",

  toMexico: [
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.valid_passport",
      i18n_tooltip_label: "",
    },
    {
      link: "/fmm",
      tooltip: true,
      underline: true,
      i18n_label: "documentation_requirements.multiple_immigration_form",
      i18n_tooltip_label:
        "documentation_requirements.multiple_immigration_form_tooltip",
    },
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.immigration_fees_payment",
      i18n_tooltip_label: "",
    },
  ],
  toUSA: [
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label:
        "documentation_requirements.valid_passport_or_permanent_residence_card",
      i18n_tooltip_label: "",
    },
  ],
  i18n_note: "usa_documentation.note",
};

const other_nationalities = {
  key: "other_nationalities_documentation",
  image: "Documentation/other_nationalities_documentation.jpg",
  i18n_title: "other_nationalities_documentation.title",
  i18n_description: "other_nationalities_documentation.description",

  toMexico: [
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.valid_passport",
      i18n_tooltip_label: "",
    },
    {
      link: "/fmm",
      label: "Forma Migratoria Múltiple",
      tooltip: true,
      underline: true,
      i18n_label: "documentation_requirements.multiple_immigration_form",
      i18n_tooltip_label:
        "documentation_requirements.multiple_immigration_form_tooltip",
    },
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label:
        "documentation_requirements.mexican_residence_card_if_applicable",
      i18n_tooltip_label: "",
    },
  ],
  toUSA: [
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label:
        "documentation_requirements.valid_passport_or_permanent_residence_card",
      i18n_tooltip_label: "",
    },
    {
      link: "",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.visa",
      i18n_tooltip_label: "",
    },
    {
      link: "/I94",
      tooltip: true,
      underline: true,
      i18n_label: "documentation_requirements.i94_permit",
      i18n_tooltip_label: "documentation_requirements.i94_permit_tooltip",
    },
    {
      link: "/I94",
      tooltip: false,
      underline: false,
      i18n_label: "documentation_requirements.esta_approval",
      i18n_tooltip_label: "",
    },
  ],
};

export const documentations = [mexico, usa, other_nationalities];
